module.exports = __webpack_public_path__ + "static/img/103064.acf1cf39.png";